export const FRONTEND_STATE_MAP_INITIALIZATION_FAILED_SET = 'FRONTEND_STATE_MAP_INITIALIZATION_FAILED/SET';
